export const ringSolutionsURLs = {
  beta: 'https://account.dev.ring.com',
  gamma: 'https://account.qa.ring.com',
  prod: 'https://account.ring.com',
};
